module.exports = __webpack_public_path__ + "img/monitoring-ship-blue.91b00f5a.svg";